<div
  class="fileUpload"
  [hidden]="isUploading">
  <input
    type="file"
    (change)="uploadFile($event)"
    [accept]="accept"
    [multiple]="multiple"
    name="uploadDocument" />
  <span>{{
    ("fileUploadInfo" | i18n) || "Datei in diesen Bereich ziehen oder klicken"
      | titlecase
  }}</span>
  <small>max. 15 MB</small>
</div>

<div
  class="uploadProgress"
  [hidden]="!isUploading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
